<template>
  <v-layout
    v-if="user"
    row
  >
    <v-flex
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
      lg6
      offset-lg3
      xl6
      offset-xl3
    >
      <div
        v-if="config.welcome_to_text"
        class="title"
      >
        <h3 class="headline mb-3">{{ $t('welcome_to') + config.welcome_to_text }}</h3>
      </div>
      <v-card
        flat
        :color="theme.login_bg_color"
      >
        <progress-bar :show="busy"></progress-bar>
        <form
          @submit.prevent="register2"
          @keydown="form.onKeydown($event)"
        >
          <v-card-text>
            <!-- First Name -->
            <v-text-field
              v-model="form.name"
              :label="$t('first_given_name')"
              prepend-icon="person"
              :error-messages="errors.collect('name')"
              name="name"
              v-validate="'required'"
              :disabled="!user.social"
            />

            <!-- Last Name -->
            <v-text-field
              v-model="form.name2"
              :label="$t('last_family_name')"
              prepend-icon="person_outline"
              :error-messages="errors.collect('name2')"
              name="name2"
              v-validate="'required'"
              :disabled="!user.social"
            />

            <!-- Email in case socialite do not provide -->
            <v-text-field
              v-model="form.email"
              :label="$t('email_ereceipt_purpose')"
              prepend-icon="email"
              :error-messages="errors.collect('email')"
              name="email"
              v-validate="'required'"
              :disabled="!user.social"
            />

            <!-- Mobile -->
            <v-layout
              row
              align-center
              mt-2
              mb-3
            >
              <v-flex
                xs1
                class="ml-1"
              >
                <v-icon size="23px">phonelink_ring</v-icon>
              </v-flex>
              <v-flex xs11>
                <vue-tel-input
                  v-model="form.mobile"
                  name="mobile"
                  :placeholder="$t('mobile')"
                  defaultCountry="SG"
                  required
                  :maxLen="15"
                  enabledCountryCode
                  validCharactersOnly
                  :wrapperClasses="['mobile-input']"
                  @validate="validateMobile"
                  @open="openMobile"
                ></vue-tel-input>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="this.form.mobile.length > 0 && !this.mobileIsValid"
              row
              align-center
              style="margin-top: -15px; margin-bottom: 5px;"
            >
              <v-flex xs1 class="ml-1"></v-flex>
              <v-flex xs11 class="ml-1">
                <span style="font-size: 12px; color: red">Your mobile number is invalid</span>
              </v-flex>
            </v-layout>

            <!-- DOB -->
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
            >
              <v-text-field
                slot="activator"
                v-model="form.birthday"
                :label="$t('birthday')"
                prepend-icon="event"
                :error-messages="errors.collect('birthday')"
                name="birthday"
                v-validate="'required|date_format:yyyy-MM-dd'"
              ></v-text-field>
              <v-date-picker
                ref="picker"
                v-model="form.birthday"
                :max="new Date().toISOString().substr(0, 10)"
                min="1930-01-01"
                @change="save"
              ></v-date-picker>
            </v-menu>

            <!-- Hidden -->
            <input
              type="hidden"
              v-model="form.group_id"
              name="group_id"
            />
            <input
              type="hidden"
              v-model="form.restaurant_id"
              name="restaurant_id"
            />
            <input
              type="hidden"
              v-model="form.loyalty_group_id"
              name="loyalty_group_id"
            />
            <v-btn
              block
              dark
              class="btn"
              :color="theme.btn_color_primary"
              type="submit"
            >
              <v-layout row>
                <v-flex
                  xs12
                  class="text-xs-center"
                  :disabled="busy"
                >
                  {{ $t('next') }}
                </v-flex>
              </v-layout>
            </v-btn>
          </v-card-text>
        </form>
      </v-card>
      <div class="text-xs-center">
        <v-btn
          flat
          :color="theme.btn_color_secondary"
          @click="changeLoginMethod"
        >
          {{ $t('change_sign_up') }}
        </v-btn>
      </div>
      <div
        class="home"
        v-if="allowCheckout.guest"
      >
        <router-link :to="{ name: 'welcome' }">{{ $t('continue_as_guest') }}</router-link>
      </div>

      <v-dialog
        v-model="dialog"
        persistent
        fullscreen
      >
        <v-card :color="theme.login_bg_color">
          <v-card-text class="pa-4">
            <div>
              Please wait for the OTP coming to your mobile phone ( <span class="mobile-otp">{{ '+' + form.country_code + '-' + form.mobile }}</span> ), and enter it below:
            </div>
            <div
              v-if="otpMsg"
              class="mt-2 mb-2 text-xs-center"
            >
              <span style="color: red">{{ otpMsg }}</span>
            </div>
            <div class="mt-3 mb-0">
              <v-text-field
                v-model="otp"
                outline
                clearable
                ref="otpField"
                name="otp"
                label="OTP"
                :color="theme.btn_color_secondary"
                @input="checkOTP"
              ></v-text-field>
            </div>
            <div
              style="margin-top: -8px;"
              class="text-xs-center"
            >
              <v-btn
                dark
                :color="btn2Color"
                @click="confirmOTP"
              >
                Confirm OTP
              </v-btn>
              <v-btn
                flat
                :color="theme.btn_color_primary"
                @click="closeOTP"
              >
                Close
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'

export default {
  name: 'register2-view',
  layout: 'default',
  metaInfo () {
    return { title: this.$t('sign_up') }
  },
  data: () => ({
    busy: false,
    menu: false,
    enableBtn: false,
    enableBtn2: false,
    dialog: false,
    isVerified: false,
    sentRequest: false,
    otp: '',
    otpMsg: '',
    otpTimer: null,
    otpMobile: null,
    otpContryCode: null,
    mobileIsValid: false,
    countryCodes: [
      { 'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore' },
      { 'flag': '🇦🇺', 'country_code': 61, 'name': 'Australia' },
      { 'flag': '🇨🇳', 'country_code': 86, 'name': 'China' },
      { 'flag': '🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'country_code': 44, 'name': 'England' },
      { 'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China' },
      { 'flag': '🇮🇳', 'country_code': 91, 'name': 'India' },
      { 'flag': '🇮🇩', 'country_code': 62, 'name': 'Indonesia' },
      { 'flag': '🇯🇵', 'country_code': 81, 'name': 'Japan' },
      { 'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia' },
      { 'flag': '🇲🇲', 'country_code': 95, 'name': 'Myanmar (Burma)' },
      { 'flag': '🇳🇿', 'country_code': 64, 'name': 'New Zealand' },
      { 'flag': '🇵🇭', 'country_code': 63, 'name': 'Philippines' },
      { 'flag': '🇰🇷', 'country_code': 82, 'name': 'South Korea' },
      { 'flag': '🇹🇼', 'country_code': 886, 'name': 'Taiwan' },
      { 'flag': '🇹🇭', 'country_code': 66, 'name': 'Thailand' },
      { 'flag': '🇬🇧', 'country_code': 44, 'name': 'United Kingdom' },
      { 'flag': '🇺🇸', 'country_code': 1, 'name': 'United States' },
      { 'flag': '🇻🇳', 'country_code': 84, 'name': 'Vietnam' },

      { 'flag': '🇦🇫', 'country_code': 93, 'name': 'Afghanistan' },
      { 'flag': '🇦🇽', 'country_code': 358, 'name': 'Åland Islands' },
      { 'flag': '🇦🇱', 'country_code': 355, 'name': 'Albania' },
      { 'flag': '🇩🇿', 'country_code': 213, 'name': 'Algeria' },
      { 'flag': '🇦🇸', 'country_code': 1, 'name': 'American Samoa' },
      { 'flag': '🇦🇴', 'country_code': 244, 'name': 'Angola' },
      { 'flag': '🇦🇮', 'country_code': 1, 'name': 'Anguilla' },
      { 'flag': '🇦🇩', 'country_code': 376, 'name': 'Andorra' },
      { 'flag': '🇦🇶', 'country_code': 672, 'name': 'Antarctica' },
      { 'flag': '🇦🇬', 'country_code': 1, 'name': 'Antigua & Barbuda' },
      { 'flag': '🇦🇷', 'country_code': 54, 'name': 'Argentina' },
      { 'flag': '🇦🇲', 'country_code': 374, 'name': 'Armenia' },
      { 'flag': '🇦🇼', 'country_code': 297, 'name': 'Aruba' },
      { 'flag': '🇦🇨', 'country_code': 247, 'name': 'Ascension Island' },
      { 'flag': '🇦🇺', 'country_code': 61, 'name': 'Australia' },
      { 'flag': '🇦🇹', 'country_code': 43, 'name': 'Austria' },
      { 'flag': '🇦🇿', 'country_code': 994, 'name': 'Azerbaijan' },

      { 'flag': '🇧🇸', 'country_code': 1, 'name': 'Bahamas' },
      { 'flag': '🇧🇭', 'country_code': 973, 'name': 'Bahrain' },
      { 'flag': '🇧🇩', 'country_code': 880, 'name': 'Bangladesh' },
      { 'flag': '🇧🇧', 'country_code': 1, 'name': 'Barbados' },
      { 'flag': '🇧🇾', 'country_code': 375, 'name': 'Belarus' },
      { 'flag': '🇧🇪', 'country_code': 32, 'name': 'Belgium' },
      { 'flag': '🇧🇿', 'country_code': 501, 'name': 'Belize' },
      { 'flag': '🇧🇯', 'country_code': 229, 'name': 'Benin' },
      { 'flag': '🇧🇲', 'country_code': 1, 'name': 'Bermuda' },
      { 'flag': '🇧🇹', 'country_code': 975, 'name': 'Bhutan' },
      { 'flag': '🇧🇴', 'country_code': 591, 'name': 'Bolivia' },
      { 'flag': '🇧🇦', 'country_code': 387, 'name': 'Bosnia & Herzegovina' },
      { 'flag': '🇧🇼', 'country_code': 267, 'name': 'Botswana' },
      { 'flag': '🇧🇻', 'country_code': 55, 'name': 'Bouvet Island' },
      { 'flag': '🇧🇷', 'country_code': 55, 'name': 'Brazil' },
      { 'flag': '🇮🇴', 'country_code': 246, 'name': 'British Indian Ocean Territory' },
      { 'flag': '🇻🇬', 'country_code': 1, 'name': 'British Virgin Islands' },
      { 'flag': '🇧🇳', 'country_code': 673, 'name': 'Brunei' },
      { 'flag': '🇧🇬', 'country_code': 359, 'name': 'Bulgaria' },
      { 'flag': '🇧🇫', 'country_code': 226, 'name': 'Burkina Faso' },
      { 'flag': '🇧🇮', 'country_code': 257, 'name': 'Burundi' },

      { 'flag': '🇰🇭', 'country_code': 855, 'name': 'Cambodia' },
      { 'flag': '🇨🇲', 'country_code': 237, 'name': 'Cameroon' },
      { 'flag': '🇨🇦', 'country_code': 1, 'name': 'Canada' },
      { 'flag': '🇮🇨', 'country_code': 34, 'name': 'Canary Islands' },
      { 'flag': '🇨🇻', 'country_code': 238, 'name': 'Cape Verde' },
      { 'flag': '🇧🇶', 'country_code': 599, 'name': 'Caribbean Netherlands' },
      { 'flag': '🇰🇾', 'country_code': 1, 'name': 'Cayman Islands' },
      { 'flag': '🇨🇫', 'country_code': 236, 'name': 'Central African Republic' },
      { 'flag': '🇪🇦', 'country_code': 11, 'name': 'Ceuta & Melilla' },
      { 'flag': '🇹🇩', 'country_code': 235, 'name': 'Chad' },
      { 'flag': '🇨🇱', 'country_code': 56, 'name': 'Chile' },
      { 'flag': '🇨🇳', 'country_code': 86, 'name': 'China' },
      { 'flag': '🇨🇽', 'country_code': 61, 'name': 'Christmas Island' },
      { 'flag': '🇨🇵', 'country_code': 11, 'name': 'Clipperton Island' },
      { 'flag': '🇨🇨', 'country_code': 891, 'name': 'Cocos (Keeling) Islands' },
      { 'flag': '🇨🇴', 'country_code': 57, 'name': 'Colombia' },
      { 'flag': '🇨🇬', 'country_code': 242, 'name': 'Congo - Brazzaville' },
      { 'flag': '🇨🇩', 'country_code': 243, 'name': 'Congo - Kinshasa' },
      { 'flag': '🇨🇰', 'country_code': 682, 'name': 'Cook Islands' },
      { 'flag': '🇰🇲', 'country_code': 269, 'name': 'Comoros' },
      { 'flag': '🇨🇷', 'country_code': 506, 'name': 'Costa Rica' },
      { 'flag': '🇨🇮', 'country_code': 225, 'name': 'Côte D\'Ivoire' },
      { 'flag': '🇭🇷', 'country_code': 385, 'name': 'Croatia' },
      { 'flag': '🇨🇺', 'country_code': 53, 'name': 'Cuba' },
      { 'flag': '🇨🇼', 'country_code': 599, 'name': 'Curaçao' },
      { 'flag': '🇨🇾', 'country_code': 357, 'name': 'Cyprus' },
      { 'flag': '🇨🇿', 'country_code': 420, 'name': 'Czechia' },

      { 'flag': '🇩🇰', 'country_code': 45, 'name': 'Denmark' },
      { 'flag': '🇩🇬', 'country_code': 246, 'name': 'Diego Garcia' },
      { 'flag': '🇩🇯', 'country_code': 253, 'name': 'Djibouti' },
      { 'flag': '🇩🇲', 'country_code': 1, 'name': 'Dominica' },
      { 'flag': '🇩🇴', 'country_code': 1, 'name': 'Dominican Republic' },

      { 'flag': '🇪🇨', 'country_code': 593, 'name': 'Ecuador' },
      { 'flag': '🇪🇬', 'country_code': 20, 'name': 'Egypt' },
      { 'flag': '🇸🇻', 'country_code': 503, 'name': 'El Salvador' },
      { 'flag': '🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'country_code': 44, 'name': 'England' },
      { 'flag': '🇬🇶', 'country_code': 240, 'name': 'Equatorial Guinea' },
      { 'flag': '🇪🇷', 'country_code': 291, 'name': 'Eritrea' },
      { 'flag': '🇪🇪', 'country_code': 372, 'name': 'Estonia' },
      { 'flag': '🇪🇺', 'country_code': 44, 'name': 'European Union' },
      { 'flag': '🇪🇹', 'country_code': 251, 'name': 'Ethiopia' },

      { 'flag': '🇫🇰', 'country_code': 500, 'name': 'Falkland Islands' },
      { 'flag': '🇫🇴', 'country_code': 298, 'name': 'Faroe Islands' },
      { 'flag': '🇫🇯', 'country_code': 679, 'name': 'Fiji' },
      { 'flag': '🇫🇮', 'country_code': 358, 'name': 'Finland' },
      { 'flag': '🇫🇷', 'country_code': 33, 'name': 'France' },
      { 'flag': '🇬🇫', 'country_code': 594, 'name': 'French Guiana' },
      { 'flag': '🇵🇫', 'country_code': 689, 'name': 'French Polynesia' },
      { 'flag': '🇹🇫', 'country_code': 262, 'name': 'French Southern Territories' },

      { 'flag': '🇬🇦', 'country_code': 241, 'name': 'Gabon' },
      { 'flag': '🇬🇲', 'country_code': 220, 'name': 'Gambia' },
      { 'flag': '🇬🇪', 'country_code': 995, 'name': 'Georgia' },
      { 'flag': '🇩🇪', 'country_code': 49, 'name': 'Germany' },
      { 'flag': '🇬🇭', 'country_code': 233, 'name': 'Ghana' },
      { 'flag': '🇬🇮', 'country_code': 350, 'name': 'Gibraltar' },
      { 'flag': '🇬🇩', 'country_code': 1, 'name': 'Grenada' },
      { 'flag': '🇬🇱', 'country_code': 299, 'name': 'Greenland' },
      { 'flag': '🇬🇷', 'country_code': 30, 'name': 'Greece' },
      { 'flag': '🇬🇵', 'country_code': 590, 'name': 'Guadeloupe' },
      { 'flag': '🇬🇺', 'country_code': 1, 'name': 'Guam' },
      { 'flag': '🇬🇹', 'country_code': 502, 'name': 'Guatemala' },
      { 'flag': '🇬🇬', 'country_code': 44, 'name': 'Guernsey' },
      { 'flag': '🇬🇳', 'country_code': 224, 'name': 'Guinea' },
      { 'flag': '🇬🇼', 'country_code': 245, 'name': 'Guinea-Bissau' },
      { 'flag': '🇬🇾', 'country_code': 592, 'name': 'Guyana' },

      { 'flag': '🇭🇹', 'country_code': 509, 'name': 'Haiti' },
      { 'flag': '🇭🇲', 'country_code': 0, 'name': 'Heard & McDonald Islands' },
      { 'flag': '🇭🇳', 'country_code': 504, 'name': 'Honduras' },
      { 'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China' },
      { 'flag': '🇭🇺', 'country_code': 36, 'name': 'Hungary' },

      { 'flag': '🇮🇸', 'country_code': 354, 'name': 'Iceland' },
      { 'flag': '🇮🇳', 'country_code': 91, 'name': 'India' },
      { 'flag': '🇮🇩', 'country_code': 62, 'name': 'Indonesia' },
      { 'flag': '🇮🇷', 'country_code': 98, 'name': 'Iran' },
      { 'flag': '🇮🇶', 'country_code': 964, 'name': 'Iraq' },
      { 'flag': '🇮🇪', 'country_code': 353, 'name': 'Ireland' },
      { 'flag': '🇮🇲', 'country_code': 44, 'name ': 'Isle of Man' },
      { 'flag': '🇮🇱', 'country_code': 972, 'name': 'Israel' },
      { 'flag': '🇮🇹', 'country_code': 39, 'name': 'Italy' },

      { 'flag': '🇯🇵', 'country_code': 81, 'name': 'Japan' },
      { 'flag': '🇯🇪', 'country_code': 44, 'name': 'Jersey' },
      { 'flag': '🇯🇲', 'country_code': 1, 'name': 'Jamaica' },
      { 'flag': '🇯🇴', 'country_code': 962, 'name': 'Jordan' },

      { 'flag': '🇰🇿', 'country_code': 7, 'name': 'Kazakhstan' },
      { 'flag': '🇰🇪', 'country_code': 254, 'name': 'Kenya' },
      { 'flag': '🇰🇮', 'country_code': 686, 'name': 'Kiribati' },
      { 'flag': '🇽🇰', 'country_code': 383, 'name': 'Kosovo' },
      { 'flag': '🇰🇼', 'country_code': 965, 'name': 'Kuwait' },
      { 'flag': '🇰🇬', 'country_code': 996, 'name': 'Kyrgyzstan' },

      { 'flag': '🇱🇦', 'country_code': 856, 'name': 'Laos' },
      { 'flag': '🇱🇻', 'country_code': 371, 'name': 'Latvia' },
      { 'flag': '🇱🇧', 'country_code': 961, 'name': 'Lebanon' },
      { 'flag': '🇱🇸', 'country_code': 266, 'name': 'Lesotho' },
      { 'flag': '🇱🇮', 'country_code': 423, 'name': 'Liechtenstein' },
      { 'flag': '🇱🇷', 'country_code': 231, 'name': 'Liberia' },
      { 'flag': '🇱🇾', 'country_code': 218, 'name': 'Libya' },
      { 'flag': '🇱🇹', 'country_code': 370, 'name': 'Lithuania' },
      { 'flag': '🇱🇺', 'country_code': 352, 'name': 'Luxembourg' },

      { 'flag': '🇲🇴', 'country_code': 853, 'name': 'Macau SAR China' },
      { 'flag': '🇲🇰', 'country_code': 389, 'name': 'Macedonia' },
      { 'flag': '🇲🇬', 'country_code': 261, 'name': 'Madagascar' },
      { 'flag': '🇲🇼', 'country_code': 265, 'name': 'Malawi' },
      { 'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia' },
      { 'flag': '🇲🇻', 'country_code': 960, 'name': 'Maldives' },
      { 'flag': '🇲🇱', 'country_code': 223, 'name': 'Mali' },
      { 'flag': '🇲🇹', 'country_code': 356, 'name': 'Malta' },
      { 'flag': '🇲🇶', 'country_code': 596, 'name': 'Martinique' },
      { 'flag': '🇲🇭', 'country_code': 692, 'name': 'Marshall Islands' },
      { 'flag': '🇲🇷', 'country_code': 222, 'name': 'Mauritania' },
      { 'flag': '🇲🇺', 'country_code': 230, 'name': 'Mauritius' },
      { 'flag': '🇾🇹', 'country_code': 262, 'name': 'Mayotte' },
      { 'flag': '🇲🇽', 'country_code': 52, 'name': 'Mexico' },
      { 'flag': '🇲🇳', 'country_code': 976, 'name': 'Mongolia' },
      { 'flag': '🇫🇲', 'country_code': 691, 'name': 'Micronesia' },
      { 'flag': '🇲🇩', 'country_code': 373, 'name': 'Moldova' },
      { 'flag': '🇲🇨', 'country_code': 377, 'name': 'Monaco' },
      { 'flag': '🇲🇿', 'country_code': 258, 'name': 'Mozambique' },
      { 'flag': '🇲🇪', 'country_code': 382, 'name': 'Montenegro' },
      { 'flag': '🇲🇸', 'country_code': 1, 'name': 'Montserrat' },
      { 'flag': '🇲🇦', 'country_code': 212, 'name': 'Morocco' },
      { 'flag': '🇲🇲', 'country_code': 95, 'name': 'Myanmar (Burma)' },

      { 'flag': '🇳🇦', 'country_code': 264, 'name': 'Namibia' },
      { 'flag': '🇳🇷', 'country_code': 674, 'name': 'Nauru' },
      { 'flag': '🇳🇨', 'country_code': 687, 'name': 'New Caledonia' },
      { 'flag': '🇳🇿', 'country_code': 64, 'name': 'New Zealand' },
      { 'flag': '🇳🇪', 'country_code': 227, 'name': 'Niger' },
      { 'flag': '🇳🇬', 'country_code': 234, 'name': 'Nigeria' },
      { 'flag': '🇳🇮', 'country_code': 505, 'name': 'Nicaragua' },
      { 'flag': '🇳🇱', 'country_code': 31, 'name': 'Netherlands' },
      { 'flag': '🇳🇫', 'country_code': 672, 'name': 'Norfolk Island' },
      { 'flag': '🇳🇴', 'country_code': 47, 'name': 'Norway' },
      { 'flag': '🇳🇵', 'country_code': 977, 'name': 'Nepal' },
      { 'flag': '🇳🇺', 'country_code': 683, 'name': 'Niue' },
      { 'flag': '🇰🇵', 'country_code': 850, 'name': 'North Korea' },
      { 'flag': '🇲🇵', 'country_code': 1, 'name': 'Northern Mariana Islands' },

      { 'flag': '🇴🇲', 'country_code': 968, 'name': 'Oman' },

      { 'flag': '🇵🇼', 'country_code': 680, 'name': 'Palau' },
      { 'flag': '🇵🇸', 'country_code': 970, 'name': 'Palestinian Territories' },
      { 'flag': '🇵🇦', 'country_code': 507, 'name': 'Panama' },
      { 'flag': '🇵🇬', 'country_code': 675, 'name': 'Papua New Guinea' },
      { 'flag': '🇵🇾', 'country_code': 595, 'name': 'Paraguay' },
      { 'flag': '🇵🇪', 'country_code': 51, 'name': 'Peru' },
      { 'flag': '🇵🇰', 'country_code': 92, 'name': 'Pakistan' },
      { 'flag': '🇵🇭', 'country_code': 63, 'name': 'Philippines' },
      { 'flag': '🇵🇳', 'country_code': 64, 'name': 'Pitcairn Islands' },
      { 'flag': '🇵🇱', 'country_code': 48, 'name': 'Poland' },
      { 'flag': '🇵🇹', 'country_code': 351, 'name': 'Portugal' },
      { 'flag': '🇵🇷', 'country_code': 1, 'name': 'Puerto Rico' },

      { 'flag': '🇶🇦', 'country_code': 974, 'name': 'Qatar' },

      { 'flag': '🇷🇪', 'country_code': 262, 'name': 'Réunion' },
      { 'flag': '🇷🇴', 'country_code': 40, 'name': 'Romania' },
      { 'flag': '🇷🇺', 'country_code': 7, 'name': 'Russia' },
      { 'flag': '🇷🇼', 'country_code': 250, 'name': 'Rwanda' },

      { 'flag': '🇼🇸', 'country_code': 685, 'name': 'Samoa' },
      { 'flag': '🇸🇲', 'country_code': 378, 'name': 'San Marino' },
      { 'flag': '🇸🇹', 'country_code': 239, 'name': 'São Tomé & Príncipe' },
      { 'flag': '🇸🇦', 'country_code': 966, 'name': 'Saudi Arabia' },
      { 'flag': '🏴󠁧󠁢󠁳󠁣󠁴󠁿', 'country_code': 44, 'name': 'Scotland' },
      { 'flag': '🇸🇳', 'country_code': 221, 'name': 'Senegal' },
      { 'flag': '🇷🇸', 'country_code': 381, 'name': 'Serbia' },
      { 'flag': '🇸🇨', 'country_code': 248, 'name': 'Seychelles' },
      { 'flag': '🇸🇱', 'country_code': 232, 'name': 'Sierra Leone' },
      { 'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore' },
      { 'flag': '🇸🇽', 'country_code': 1, 'name': 'Sint Maarten' },
      { 'flag': '🇸🇰', 'country_code': 421, 'name': 'Slovakia' },
      { 'flag': '🇸🇮', 'country_code': 386, 'name': 'Slovenia' },
      { 'flag': '🇸🇧', 'country_code': 677, 'name': 'Solomon Islands' },
      { 'flag': '🇸🇴', 'country_code': 252, 'name': 'Somalia' },
      { 'flag': '🇿🇦', 'country_code': 27, 'name': 'South Africa' },
      { 'flag': '🇬🇸', 'country_code': 500, 'name': 'South Georgia & South Sandwich Islands' },
      { 'flag': '🇰🇷', 'country_code': 82, 'name': 'South Korea' },
      { 'flag': '🇸🇸', 'country_code': 211, 'name': 'South Sudan' },
      { 'flag': '🇪🇸', 'country_code': 34, 'name': 'Spain' },
      { 'flag': '🇱🇰', 'country_code': 94, 'name': 'Sri Lanka' },
      { 'flag': '🇧🇱', 'country_code': 590, 'name': 'St. Barthélemy' },
      { 'flag': '🇸🇭', 'country_code': 290, 'name': 'St. Helena' },
      { 'flag': '🇰🇳', 'country_code': 1, 'name': 'St. Kitts & Nevis' },
      { 'flag': '🇱🇨', 'country_code': 1, 'name': 'St. Lucia' },
      { 'flag': '🇲🇫', 'country_code': 590, 'name': 'St. Martin' },
      { 'flag': '🇵🇲', 'country_code': 508, 'name': 'St. Pierre & Miquelon' },
      { 'flag': '🇻🇨', 'country_code': 1, 'name': 'St. Vincent & Grenadines' },
      { 'flag': '🇸🇩', 'country_code': 249, 'name': 'Sudan' },
      { 'flag': '🇸🇷', 'country_code': 597, 'name': 'Suriname' },
      { 'flag': '🇸🇯', 'country_code': 47, 'name': 'Svalbard & Jan Mayen' },
      { 'flag': '🇸🇪', 'country_code': 46, 'name': 'Sweden' },
      { 'flag': '🇨🇭', 'country_code': 41, 'name': 'Switzerland' },
      { 'flag': '🇸🇿', 'country_code': 268, 'name': 'Swaziland' },
      { 'flag': '🇸🇾', 'country_code': 963, 'name': 'Syria' },

      { 'flag': '🇹🇼', 'country_code': 886, 'name': 'Taiwan' },
      { 'flag': '🇹🇯', 'country_code': 992, 'name': 'Tajikistan' },
      { 'flag': '🇹🇿', 'country_code': 255, 'name': 'Tanzania' },
      { 'flag': '🇹🇭', 'country_code': 66, 'name': 'Thailand' },
      { 'flag': '🇹🇱', 'country_code': 670, 'name': 'Timor-Leste' },
      { 'flag': '🇹🇦', 'country_code': 290, 'name': 'Tristan Da Cunha' },
      { 'flag': '🇹🇬', 'country_code': 228, 'name': 'Togo' },
      { 'flag': '🇹🇰', 'country_code': 690, 'name': 'Tokelau' },
      { 'flag': '🇹🇴', 'country_code': 676, 'name': 'Tonga' },
      { 'flag': '🇹🇹', 'country_code': 1, 'name': 'Trinidad & Tobago' },
      { 'flag': '🇹🇳', 'country_code': 216, 'name': 'Tunisia' },
      { 'flag': '🇹🇲', 'country_code': 993, 'name': 'Turkmenistan' },
      { 'flag': '🇹🇷', 'country_code': 90, 'name': 'Turkey' },
      { 'flag': '🇹🇨', 'country_code': 1, 'name': 'Turks & Caicos Islands' },
      { 'flag': '🇹🇻', 'country_code': 688, 'name': 'Tuvalu' },

      { 'flag': '🇺🇬', 'country_code': 256, 'name': 'Uganda' },
      { 'flag': '🇺🇦', 'country_code': 380, 'name': 'Ukraine' },
      { 'flag': '🇦🇪', 'country_code': 971, 'name': 'United Arab Emirates' },
      { 'flag': '🇬🇧', 'country_code': 44, 'name': 'United Kingdom' },
      { 'flag': '🇺🇳', 'country_code': 92, 'name': 'United Nations' },
      { 'flag': '🇺🇸', 'country_code': 1, 'name': 'United States' },
      { 'flag': '🇺🇾', 'country_code': 598, 'name': 'Uruguay' },
      { 'flag': '🇺🇿', 'country_code': 998, 'name': 'Uzbekistan' },
      { 'flag': '🇺🇲', 'country_code': 0, 'name': 'U.S. Outlying Islands' },
      { 'flag': '🇻🇮', 'country_code': 1, 'name': 'U.S. Virgin Islands' },

      { 'flag': '🇻🇺', 'country_code': 678, 'name': 'Vanuatu' },
      { 'flag': '🇻🇦', 'country_code': 379, 'name': 'Vatican City' },
      { 'flag': '🇻🇪', 'country_code': 58, 'name': 'Venezuela' },
      { 'flag': '🇻🇳', 'country_code': 84, 'name': 'Vietnam' },

      { 'flag': '🏴󠁧󠁢󠁷󠁬󠁳󠁿', 'country_code': 44, 'name': 'Wales' },
      { 'flag': '🇼🇫', 'country_code': 681, 'name': 'Wallis & Futuna' },
      { 'flag': '🇪🇭', 'country_code': 212, 'name': 'Western Sahara' },

      { 'flag': '🇾🇪', 'country_code': 967, 'name': 'Yemen' },

      { 'flag': '🇿🇲', 'country_code': 260, 'name': 'Zambia' },
      { 'flag': '🇿🇼', 'country_code': 263, 'name': 'Zimbabwe' }
    ]
  }),
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'restaurant', 'allowCheckout', 'colors', 'config', 'requireMobileOTP',
      'loyaltyGroupId'
    ]),
    ...mapGetters('auth', [
      'user', 'authenticated', 'token', 'hasAnyMember'
    ]),
    ...mapGetters('member', [
      'profile', 'isMember'
    ]),
    form () {
      let email = this.needValidEmail() ? '' : this.user.email
      return new Form({
        name: this.user ? this.user.name : '',
        name2: this.user ? this.user.name2 : '',
        email: email,
        country_code: 65,
        mobile: '',
        birthday: '',
        group_id: this.restaurant.group_id,
        restaurant_id: parseInt(this.restaurant.restaurant_id),
        loyalty_group_id: (!this.loyaltyGroupId || this.loyaltyGroupId === 0) ? 0 : this.loyaltyGroupId,
        referral_id: this.user ? this.user.referral_id : 0,
      })
    },
    hint () {
      return '(' + this.form.country_code + ')'
    },
    btnColor () {
      if (this.enableBtn) {
        return this.theme.btn_color_secondary
      }
      return this.theme.btn_color_disabled
    },
    btn2Color () {
      if (this.enableBtn2) {
        return this.theme.btn_color_secondary
      }
      return this.theme.btn_color_disabled
    },
    myCallback () {
      if (this.$route.query.callback) {
        const url = this.$route.query.callback
        return url
      }
      return null
    },
    triggerMobileOTP () {
      return (process.env.NODE_ENV === 'production') && this.requireMobileOTP
    }
  },
  methods: {
    needValidEmail () {
      return this.user.social_id && parseInt(this.user.email.split('@')[0]) === parseInt(this.user.social_id)
    },
    async changeLoginMethod () {
      if (!this.hasAnyMember) {
        const result = await axios.post('/api/user/remove')
        if (result.data === 1) {
          this.$store.dispatch('order/resetOrderData')
          this.$store.dispatch('auth/resetUser')
          this.$router.push({ name: 'register' })
        }
      }
      else {
        this.$store.dispatch('order/resetOrderData')
        this.$store.dispatch('auth/resetUser')
        this.$router.push({ name: 'register' })
      }
    },
    closeOTP () {
      this.dialog = false
    },
    checkOTP () {
      if (this.otp.length >= 6) {
        this.enableBtn2 = true
      } else {
        this.enableBtn2 = false
      }
    },
    async confirmOTP () {
      if (this.enableBtn2 || this.otp.length >= 6) {
        const { data } = await axios.post('/api/otp/verify', {
          otp: this.otp,
          mobile: this.form.mobile.replace(/\D/g, '')
        })
        if (data === 1) {
          this.isVerified = true
          this.dialog = false
          if (await this.formHasErrors()) return
          this.register2()
        } else {
          this.otpMsg = 'Verification failed'
        }
      }
    },
    checkMobile () {
      if (this.form.mobile.length >= 8) {
        this.enableBtn = true
      } else {
        this.enableBtn = false
      }
    },
    async requireOTP () {
      if (this.enableBtn) {
        this.otpMsg = ''
        this.dialog = true
        this.$nextTick(() => {
          this.$refs.otpField.focus()
        })
        await axios.post('/api/otp/get', {
          country_code: this.form.country_code,
          mobile: this.form.mobile.replace(/\D/g, ''),
          group_id: this.restaurant.group_id,
          restaurant_id: this.restaurant.restaurant_id
        })
      }
    },
    save (date) {
      this.$refs.menu.save(date)
    },
    allowResendOTP () {
      const waitingTime = 30
      if (!this.otpTimer || !this.otpMobile || !this.otpContryCode) {
        this.otpTimer = moment().add(waitingTime, 'seconds')
        this.otpMobile = this.form.mobile.replace(/\D/g, '')
        this.otpContryCode = this.form.country_code
        return true
      }
      if (this.form.mobile.replace(/\D/g, '') !== this.otpMobile || this.form.country_code !== this.otpContryCode) {
        this.otpTimer = moment().add(waitingTime, 'seconds')
        this.otpMobile = this.form.mobile.replace(/\D/g, '')
        this.otpContryCode = this.form.country_code
        return true
      }
      if (moment().isAfter(this.otpTimer)) {
        this.otpTimer = moment().add(waitingTime, 'seconds')
        this.otpMobile = this.form.mobile.replace(/\D/g, '')
        this.otpContryCode = this.form.country_code
        return true
      }
      return false
    },
    validateMobile ({ number, isValid, country }) {
      this.mobileIsValid = isValid
      this.form.country_code = country.dialCode
      if (isValid && number.significant) {
        this.form.mobile = number.significant
      }
    },
    openMobile () {
      // Manually set using JS because CSS isn't applying the style
      const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style
      if (dropdownElementStyle) {
        dropdownElementStyle.fontSize = "14px"
        dropdownElementStyle.width = "230px"
      }
    },
    async register2 () {
      if (await this.formHasErrors()) return

      if (!this.mobileIsValid) {
        return
      }

      this.busy = true

      const { data } = await axios.post('/api/member/check', {
        mobile: this.form.mobile.replace(/\D/g, ''),
        loyalty_group_id: this.form.loyalty_group_id,
        email: this.form.email,
      })

      if (data.code === 0) {
        this.busy = false
        const msg = 'mobile_existed_' + data.method
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('registration_fail'),
          text: this.$t(msg) + data.email + ', ' + this.$t('use_same_login'),
          modal: true
        })
        return
      }

      if (!this.isVerified && this.triggerMobileOTP) {
        this.busy = false
        this.otpMsg = ''
        this.dialog = true
        this.$nextTick(() => {
          this.$refs.otpField.focus()
        })

        if (this.allowResendOTP()) {
          await axios.post('/api/otp/get', {
            country_code: this.form.country_code,
            mobile: this.form.mobile.replace(/\D/g, ''),
            group_id: this.restaurant.group_id,
            restaurant_id: this.restaurant.restaurant_id
          })
        }
        return
      }

      try {
        // Register the user.
        const info = {
          name: this.form.name,
          name2: this.form.name2,
          email: this.form.email,
          country_code: this.form.country_code,
          mobile: this.form.mobile.replace(/\D/g, ''),
          birthday: this.form.birthday,
          group_id: this.form.group_id,
          restaurant_id: parseInt(this.form.restaurant_id),
          loyalty_group_id: this.form.loyalty_group_id,
          referral_id: this.form.referral_id,
        }

        const { data } = await axios.post('/api/member', { info: info })

        // Update the user and member.
        if (data.code === 1) {
          await this.$store.dispatch('auth/updateUser', data.user)
          await this.$store.dispatch('member/updateProfile', data.member)
          this.busy = false

          // facebook callback
          if (this.myCallback) {
            const params = {
              callback: this.myCallback,
              fb: this.user.social_id
            }
            axios.post('/api/fb/callback', params)
          }
          // Redirect home.
          this.$router.push({ name: 'home' })
        } else {
          this.busy = false
          this.isVerified = false
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: this.$t('registration_fail'),
            text: data.msg,
            modal: true
          })
        }
      } catch (e) {
        this.busy = false
        this.isVerified = false
      }
    }
  },
  async created () {
    const dict = {
      custom: {
        name: {
          required: 'Please enter your first name / given name'
        },
        name2: {
          required: 'Please enter your last name / family name'
        },
        email: {
          required: 'Please enter your email (for e-receipt)'
        },
        mobile: {
          required: 'Please enter your mobile number'
        },
        birthday: {
          required: 'Please enter your birthday'
        },
        // country: {
        //   required: 'Please select your country / region'
        // },
        otp: {
          required: 'Please enter OTP code'
        }
      }
    }
    this.$validator.localize('en', dict)
    if (!this.token) {
      this.$router.push({ name: 'login' })
    } else {
      await this.$store.dispatch('auth/fetchUser')
      await this.$store.dispatch('member/fetchProfile')
      if (this.isMember) {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-top: 15px;
}
.btn {
  margin: 24px 0 0;
}
.home {
  text-align: center;
  margin-top: 30px;
}
.mobile-otp {
  font-weight: 800;
}
.mobile-input {
  border-top: 0px !important;
  border-left: 0px !important;
  border-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/register2.vue